import React, {Component} from 'react';
import UserGroupAttributesRow from "./UserGroupAttributesRow";
import {PropTypes} from 'prop-types';
import * as messageConstants from '../../../shared/messages';


class UserGroupAttributesTable extends Component {
  static propTypes = {
    onRowAdd: PropTypes.func,
    onRowDel: PropTypes.func,
    onUserGroupAttributesTableUpdate: PropTypes.func,
    UserGroupAttributes: PropTypes.any,
  }

  handleRowAdd = () => {
    this.props.onRowAdd();
  }

  handleRowDel = (target) => {
    this.props.onRowAdd(target);
  }

  render() {
    const userGroupAttributeRows = this.props.UserGroupAttributes
        ? this.props.UserGroupAttributes.map(
            (userGroupAttribute, index) =>
                <UserGroupAttributesRow
                    onUserGroupAttributesTableUpdate={this.props.onUserGroupAttributesTableUpdate}
                    userGroupAttribute={userGroupAttribute}
                    displayGroupAttributes={this.props.displayGroupAttributes}
                    onRowDel={this.props.onRowDel}
                    id={index}
                    key={index}/>
        ) : [];
    return ( this.props.displayUserGroupAttributes ?
        <div>
          <table>
            <tbody>
            {userGroupAttributeRows.length > 0 ? <tr>
              <th className="attribute-name-title">
                {messageConstants.USER_GROUP_ATTRIBUTE_NAME}
              </th>
              <th className="attribute-dropdown-title pl-12">
                {messageConstants.USER_GROUP_ATTRIBUTE_FILTER}
              </th>
            </tr> : null}
            {userGroupAttributeRows}

            <tr>
              <td className="add-attribute">
                <button type="button" onClick={this.handleRowAdd}
                        className="attr-button group-attr-button ">
                  <span className="fa fa-plus btn-circle btn-plus"/>
                  <span
                      className="attr-button-label">{messageConstants.BUTTON_ADD_GROUP_ATTRIBUTE}</span>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
          <br/>
        </div> : null
    );

  }

}

export default UserGroupAttributesTable;
